var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9062 0C18.9062 14.5234 11.0859 27.5 0 27.5C11.0859 27.5 18.9062 40.4766 18.9062 55C18.9062 40.4766 26.7266 27.5 37.8125 27.5C26.7266 27.5 18.9062 14.5234 18.9062 0Z",
    fill: "#FFE54D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5469 0C45.5469 7.21875 41.5938 13.75 36.0938 13.75C41.5938 13.75 45.5469 20.2812 45.5469 27.5C45.5469 20.2812 49.5 13.75 55 13.75C49.5 13.75 45.5469 7.21875 45.5469 0Z",
    fill: "#6ADBC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 27.5C41.25 34.7187 37.2969 41.25 31.7969 41.25C37.2969 41.25 41.25 47.7812 41.25 55C41.25 47.7812 45.2031 41.25 50.7031 41.25C45.2031 41.25 41.25 34.7187 41.25 27.5Z",
    fill: "#FF73C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.c6ce5bd1e166ebb5cd709660711ffb78.svg";
export { ForwardRef as ReactComponent };